import React, { useEffect } from 'react';
import SemiStore from '@/stores/semi';
import classNames from 'classnames';

export default function ShippingList(props: ShippingTypes.Root) {
  const { logisticsList, indexSelected, productId } = props;

  const semiStore = SemiStore((state) => state);
  const { setLogistics, priceIndex = indexSelected, setExpressType } = semiStore;

  // 展示同步数据或更新数据
  const logisticsListData =
    semiStore.logisticsList.length > 0 ? semiStore.logisticsList : logisticsList;
  const { listData, defaultLogistics, negotiatedInfo } = logisticsListData[priceIndex];

  useEffect(() => {
    setLogistics(logisticsList, indexSelected);
    document.querySelector('.no-shipping u')?.addEventListener('click', () => {
      (document.querySelector('[data-type-btn=inquiry]') as HTMLElement)?.click();
    });
  }, []);

  // 物流曝光打点
  useEffect(() => {
    const q = window.goldlog_queue || (window.goldlog_queue = []);
    q.push({
      action: 'goldlog.record',
      arguments: [
        '/sc.detail_pc_halfdelegated_logistic',
        'EXP',
        `params=${JSON.stringify(
          listData?.filter((i) => i.type === defaultLogistics),
        )}&productId=${productId}`,
        'POST',
      ],
    });
  }, [priceIndex]);

  return (
    <div className="shipping-list">
      {negotiatedInfo?.text && (
        <div
          className="no-shipping"
          dangerouslySetInnerHTML={{
            __html: negotiatedInfo?.text,
          }}
        ></div>
      )}
      {listData?.map((item) => (
        <div
          className={classNames({
            'shipping-item': true,
            activated: item.type === defaultLogistics,
          })}
          key={item.type}
          onClick={() => setExpressType(item.type, logisticsList)}
        >
          <div className="shipping-title">{item.method}</div>
          <div
            className="shipping-intro"
            dangerouslySetInnerHTML={{
              __html: `${item.mcms_price_title} ${item.price}`,
            }}
          ></div>
          <div
            className="shipping-delivery"
            dangerouslySetInnerHTML={{
              __html: item.deliveredDate,
            }}
          ></div>
        </div>
      ))}
    </div>
  );
}
